import React from "react";

const About = () => {
  return (
    <div className="py-10 sm:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
        <h1 className="text-2xl sm:text-2xl font-bold text-center flex items-center justify-center space-x-2 text-gray-800 mb-16">
          <span>Welcome to</span>
          <span className="text-black py-2 px-4 border border-gray-800 rounded-xl">
            Academy-nest
          </span>
        </h1>
        <p className="text-base sm:text-lg text-center text-gray-700 leading-relaxed mb-28">
          At{" "}
          <span className="font-semibold text-gray-800">
            Academy-<span className="text-gray-500">nest</span>
          </span>
          , we believe education is the key to unlocking potential. Our
          innovative platform connects teachers and students worldwide, offering
          a seamless learning experience powered by live, interactive classes.
        </p>

        <div className="grid gap-9 sm:grid-cols-2">
          <div>
            <h2 className="text-lg font-medium w-fit text-black py-1 px-4 border border-gray-800 rounded-xl mb-4">
              For Parents
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Academy-nest ensures that parents stay informed and engaged in
              their child's learning journey. With access to course updates,
              progress reports, and live session schedules, parents can support
              their children’s education with ease and confidence.
            </p>
          </div>

          <div>
            <h2 className="text-lg font-medium w-fit text-black py-1 px-4 border border-gray-800 rounded-xl mb-4">
              For Students
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Students can easily enroll in courses, join live sessions, and
              access learning materials from anywhere. With real-time
              interaction, learning becomes engaging and collaborative.
            </p>
          </div>
        </div>

        <div className="mt-28">
          <h2 className="text-2xl font-medium text-center text-gray-800 mb-6">
            Why Choose Us?
          </h2>
          <ul className="space-y-4">
            <li className="flex items-start">
              <div className="flex w-8 h-8 justify-center items-center bg-mainColor text-white rounded-full p-2 mr-4">
                ✓
              </div>
              <p className="text-gray-700 leading-relaxed">
                <span className="font-semibold">Secure Learning:</span>{" "}
                Protecting your data is our top priority with encrypted session
                storage.
              </p>
            </li>
            <li className="flex items-start">
              <div className="flex w-8 h-8 justify-center items-center bg-mainColor text-white rounded-full p-2 mr-4">
                ✓
              </div>
              <p className="text-gray-700 leading-relaxed">
                <span className="font-semibold">Global Access:</span> Learn from
                anywhere in the world.
              </p>
            </li>
            <li className="flex items-start">
              <div className="flex w-8 h-8 justify-center items-center bg-mainColor text-white rounded-full p-2 mr-4">
                ✓
              </div>
              <p className="text-gray-700 leading-relaxed">
                <span className="font-semibold">Real-Time Interaction:</span>{" "}
                Foster collaboration with live, interactive classes.
              </p>
            </li>
          </ul>
        </div>

        <div className="mt-10 text-center">
          <a
            href="/enroll"
            className="inline-block bg-blue-500 hover:bg-blue-600 text-white text-lg font-medium px-6 py-3 rounded-full shadow-md transition duration-300"
          >
            Get Started Today
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
